import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useAnalytics } from "@/hooks/useAnalytics";

export const RootLayout = () => {
  // Track all route changes globally
  useAnalytics();

  return <Outlet />;
};
